import React from 'react';

import { Box } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';

const useStyles = makeStyles(() => ({
  box: {
    width: '100%',
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: '#E4EBF1'
  }
}));

const DisconnectedView = () => {

  const classes = useStyles();

  return (
    <>
      <Box className={ classes.box } ></Box>
    </>
  );

};

export default DisconnectedView;
